
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:flex;
  flex-direction:column;
  height:100%;
}

outline-heading-baseline *{
  --heading-color:var(--brand-primary-dark-blue);
}

.container{
  background-color:var(--brand-gray-200);
}

.content{
  display:flex;
  flex-direction:column;
  padding:var(--spacing-7);
  height:100%;
  width:100%;
}

.rule{
  border:solid var(--brand-green-900);
  border-width:8px 0 0;
  height:1px;
  padding:0;
  position:relative;
  text-align:left;
  width:100%;
  margin:10px 0 20px;
  border-radius:3px;
  border-top-width:3px;
}

.contact-info{
  margin-top:var(--spacing-2);
  margin-bottom:var(--spacing-7);
}

div[slot='phone'],
div[slot='email']{
  color:var(--brand-dark-blue-900);
  font-size:var(--fs-base);
  line-height:2;
  word-break:break-word;
}

div[slot='phone'] a, div[slot='email'] a{
    margin:0 -0.1875rem 0.1875rem;
    padding:0 0.1875rem;
    border-bottom:2px solid var(--brand-dark-blue-900);
    border-top:2px solid transparent;
    transition:background-color 0.425s, border-color 0.425s;
  }

div[slot='phone'] a:hover,
    div[slot='phone'] a:focus,
    div[slot='email'] a:hover,
    div[slot='email'] a:focus{
      background-color:var(--brand-green-900);
    }

div[slot='phone'] a:focus, div[slot='email'] a:focus{
      background-color:var(--brand-green-900);
      border-top-color:var(--brand-dark-blue-900);
      outline:none;
    }

.cta{
  flex-grow:1;
  display:flex;
  align-items:flex-end;
}

.btn{
  width:100%;
  justify-content:center;
}

@media (min-width: 768px){

.btn{
    width:auto;
    justify-content:flex-start
}
  }
`;